"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    desc: "<p>\u041F\u0440\u0435\u043C\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430.</p>",
};
